/** Check if running in a browser environment */
export function isBrowser(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof navigator !== 'undefined'
  );
}

/** Classify a performance value into rating */
export function classifyRating(
  value: number,
  goodThreshold: number,
  poorThreshold: number,
): 'good' | 'needs-improvement' | 'poor' {
  if (value <= goodThreshold) return 'good';
  if (value <= poorThreshold) return 'needs-improvement';
  return 'poor';
}

/** Safe get current page URL */
export function getPageUrl(): string {
  if (!isBrowser()) return '';
  return location.href;
}
